import api from './api.service';

class PaymentService {
    private url: string = 'payments/requisites';

    postPaymentLegal(data: any) {
        return api.post(`${this.url}/legal`, data)
    }

    postPaymentIndividual(data: any) {
        return api.post(`${this.url}/individual`, data)
    }
    putPaymentLegal(requisite_id:string,data: any) {
        return api.put(`${this.url}/legal/${requisite_id}`, data)
    }
    putPaymentIndividual(requisite_id:string,data: any) {
        return api.put(`${this.url}/individual/${requisite_id}`, data)
    }

    getPayments() {
        return api.get(this.url)
    }
    getRequisites(requisite_id:string){
        return api.get(`${this.url}/${requisite_id}`)
    }
    deleteRequisites(requisite_id:string){
        return api.delete(`${this.url}/${requisite_id}`)
    }
    
    getPayment(course_id: string) {
        return api.get(`robokassa/url/${course_id}`)
    }

}

export const paymentService = new PaymentService();